<template>
  <div class="width-100 mainBox flex-column justify-content-start align-items-center" style="min-width: 1200px">
    <!--    顶部菜单栏-->
    <tab class="fixed" selectTab="6" style="min-width: 1200px"></tab>

    <img src="@/assets/image/banner7.jpg" width="100%" alt="" />
    <div class="main flex-row justify-content-spaceBetween align-items-center margin-ts margin-b border-b">
      <p class="fs-mid grey">当前位置：首页 > 专题专栏</p>
    </div>
    <div class="flex-row justify-content-start align-items-star flex-wrap main">
      <div
        @mouseenter="addClassload(index)"
        @mouseleave="removeClassload()"
        @click="projectJump(item)"
        :class="{ boxShadow: classenable && current === index }"
        v-for="(item, index) in project"
        :key="index"
        class="list br-reg pointer select"
      >
        <van-image width="100%" class="height160 van-overflow-hidden br-reg" :src="imagePrefix + item.poster" alt="" />
        <div class="width-90 paddingLr90">
          <p class="fs-big fw-mid lineHeight2 width-100 cutText">{{ item.typeName }}</p>
          <p class="fs-sml width-100 grey"><van-icon color="#cccccc" class="margin-rs" name="clock" />{{ item.createTime.substring(0, 10) }}</p>
        </div>
      </div>
    </div>

    <van-pagination class="margin-ts" v-model="currentPage" :total-items="project.length" :show-page-size="5">
      <template #prev-text>
        <van-icon name="arrow-left" />
      </template>
      <template #next-text>
        <van-icon name="arrow" />
      </template>
      <template #page="{ text }">{{ text }}</template>
    </van-pagination>

    <backBtn></backBtn>

    <footerBox class="margin-t"></footerBox>
  </div>
</template>
<script>
import tab from '@/components/tab.vue';
import footerBox from '@/components/footer.vue';
import backBtn from '@/components/backBtn.vue';
import config from '@/config';
import newsApi from '@/api/newsApi';

export default {
  name: 'projectList',
  components: {
    tab,
    footerBox,
    backBtn
  },
  data() {
    return {
      imagePrefix: config.IMAGE_PREFIX,
      currentPage: 1,
      classenable: false,
      current: 0,
      project: []
    };
  },
  mounted() {},

  created() {
    newsApi
      .listType({ isProject: 1 })
      .then((res) => {
        this.project = res.data;
      })
      .catch((err) => {
        console.log(err);
      });
  },
  methods: {
    addClassload(e) {
      this.classenable = true;
      this.current = e;
    },
    removeClassload() {
      this.classenable = false;
      // this.current=index;
    },
    projectJump(item) {
      if (item.indexBannerUrl !== null) {
        window.open(item.indexBannerUrl, '_blank');
      } else {
        let text = this.$router.resolve({ path: '/project', query: { id: item.id } });
        // 打开一个新的页面
        window.open(text.href, '_blank');
      }
    },
    jumpTo(e, m) {
      let text = this.$router.resolve({ path: e, query: { id: m } });
      // 打开一个新的页面
      window.open(text.href, '_blank');
    }
  }
};
</script>

<style lang="less" scoped>
.fixed {
  position: fixed;
  top: 0;
  z-index: 99;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
}
.mainBox {
  height: 200px;
  padding-top: 60px;
}
.search {
  border: none !important;
}
.searchBox {
  padding: 4px 10px;
  border-radius: 5px;
}
.border-b {
  border-bottom: 1px solid #eeeeee;
  padding-bottom: 20px;
}
.list {
  width: 22.5%;
  height: 240px;
  border: 1px solid #eeeeee;
  margin: 0 1% 20px;
}
.height160 {
  height: 160px;
}
</style>
<style>
.van-pagination__item--active {
  background-color: rgb(11, 73, 158) !important;
  color: #ffffff !important;
}
.van-pagination__item {
  min-width: 30px;
  height: 30px;
  margin: 0 3px;
  border: 1px solid #eeeeee;
  color: #666666;
}
</style>
